import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Domain\Blog\Http\Controllers\Public\PostController::index
* @see app/Domain/Blog/Http/Controllers/Public/PostController.php:26
* @route '/{type}'
*/
export const index = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/{type}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Blog\Http\Controllers\Public\PostController::index
* @see app/Domain/Blog/Http/Controllers/Public/PostController.php:26
* @route '/{type}'
*/
index.url = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { type: args }
    }

    if (Array.isArray(args)) {
        args = {
            type: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
    }

    return index.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Blog\Http\Controllers\Public\PostController::index
* @see app/Domain/Blog/Http/Controllers/Public/PostController.php:26
* @route '/{type}'
*/
index.get = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Public\PostController::index
* @see app/Domain/Blog/Http/Controllers/Public/PostController.php:26
* @route '/{type}'
*/
index.head = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Public\PostController::index
* @see app/Domain/Blog/Http/Controllers/Public/PostController.php:26
* @route '/{type}'
*/
const indexForm = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Public\PostController::index
* @see app/Domain/Blog/Http/Controllers/Public/PostController.php:26
* @route '/{type}'
*/
indexForm.get = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Public\PostController::index
* @see app/Domain/Blog/Http/Controllers/Public/PostController.php:26
* @route '/{type}'
*/
indexForm.head = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Domain\Blog\Http\Controllers\Public\PostController::show
* @see app/Domain/Blog/Http/Controllers/Public/PostController.php:40
* @route '/{type}/{slug}'
*/
export const show = (args: { type: string | number, slug: string | number } | [type: string | number, slug: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/{type}/{slug}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Blog\Http\Controllers\Public\PostController::show
* @see app/Domain/Blog/Http/Controllers/Public/PostController.php:40
* @route '/{type}/{slug}'
*/
show.url = (args: { type: string | number, slug: string | number } | [type: string | number, slug: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            type: args[0],
            slug: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
        slug: args.slug,
    }

    return show.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace('{slug}', parsedArgs.slug.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Blog\Http\Controllers\Public\PostController::show
* @see app/Domain/Blog/Http/Controllers/Public/PostController.php:40
* @route '/{type}/{slug}'
*/
show.get = (args: { type: string | number, slug: string | number } | [type: string | number, slug: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Public\PostController::show
* @see app/Domain/Blog/Http/Controllers/Public/PostController.php:40
* @route '/{type}/{slug}'
*/
show.head = (args: { type: string | number, slug: string | number } | [type: string | number, slug: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Public\PostController::show
* @see app/Domain/Blog/Http/Controllers/Public/PostController.php:40
* @route '/{type}/{slug}'
*/
const showForm = (args: { type: string | number, slug: string | number } | [type: string | number, slug: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Public\PostController::show
* @see app/Domain/Blog/Http/Controllers/Public/PostController.php:40
* @route '/{type}/{slug}'
*/
showForm.get = (args: { type: string | number, slug: string | number } | [type: string | number, slug: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Public\PostController::show
* @see app/Domain/Blog/Http/Controllers/Public/PostController.php:40
* @route '/{type}/{slug}'
*/
showForm.head = (args: { type: string | number, slug: string | number } | [type: string | number, slug: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

const blog = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
}

export default blog